import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import AssessmentActions from 'components/checkIn/questionnaire/AssessmentActions';

const WaitForLoading = () => {
  const copy = useCopy();
  return <AssessmentActions blurb={copy.blurb} />;
};
export default WaitForLoading;

const useCopy = () => {
  const copy = defineMessages({
    waitingForLoading: {
      id: 'check-in.loading-status.blurb',
      defaultMessage: 'Please, wait while your answers are being loaded ...',
    },
  });

  const intl = useIntl();
  const blurb = intl.formatMessage(copy.waitingForLoading);

  return { blurb };
};
